var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "mobile-tooltip"
  }, [_c('div', {
    staticClass: "mobile-tooltip__trigger",
    on: {
      "touchstart": _vm.handleTouchStart,
      "touchend": _vm.handleTouchEnd,
      "click": _vm.handleClick
    }
  }, [_vm._t("activator")], 2), _c('transition', {
    attrs: {
      "name": "mobile-tooltip"
    }
  }, [_vm.isVisible ? _c('div', {
    staticClass: "mobile-tooltip__content"
  }, [_c('div', {
    staticClass: "mobile-tooltip__text"
  }, [_vm._t("default")], 2)]) : _vm._e()])], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }